import * as ReselectModule from "reselect";
import { IClientDebtListState } from ".";
import { IApplicationState } from "..";

export const selectClientDebtList: ReselectModule.Selector<
  IApplicationState,
  IClientDebtListState
> = (state) => state.clientDebtList;
